<template>
  <div class="lte-modem-card">
    <div class="lte-modem-card__header">
      <span>
        <div class="lte-modem-card__header--indicator indicator"></div>
        <div class="lte-modem-card__header--text">LTE Modem {{ header }}</div>
      </span>
      <div class="lte-modem-card__header--icons">
        <div class="lte-modem-card__header--more pointer">
          <span
            @click.prevent="openModal"
            class="edit-btn mdi mdi-border-color"
          ></span>
        </div>
      </div>
    </div>
    <div class="lte-modem-card__container">
      <div class="lte-modem-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.modems.work_mode") }}
        </div>
        <div class="text">
          {{ dataModem.mode ? dataModem.mode : "AUTO" }}
        </div>
      </div>
      <div class="lte-modem-card__container--row">
        <div class="title">APN</div>
        <div class="text">
          {{ dataModem.apn ? dataModem.apn : "N/A" }}
        </div>
      </div>
      <div class="lte-modem-card__container--row">
        <div class="title">
          {{ translate("device.config_dashboard.modems.wan_interfaces") }}
        </div>
        <div class="text">
          {{
            (dataModem.wanTunnels && dataModem.wanTunnels.length != 0)
              ? dataModem.wanTunnels.toString()
              : "N/A"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModemsModal from "./ModemsModal.vue";

export default {
  name: "Modems",
  components: {},
  props: {
    header: String,
    dataModem: Object,
    listWanTunnels: Array,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    openModal(val) {
      var t = this.$createElement(ModemsModal, {
        props: {
          dataModem: this.dataModem,
          header: this.header,
          listWanTunnels: this.listWanTunnels,
        },
        on: {
          close: () => {
            this.$modal.hide("dynamic-modal");
          },
          update: (data) => {
            this.$emit("update", data);
          },
          delete: (val) => {
            this.delete_channel(val);
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
        temp,
        {},
        {
          height: "auto",
          adaptive: true,
          clickToClose: true,
          scrollable: true,
          name: "dynamic-modal",
        }
      );
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.lte-modem-card {
  color: #fff;
  background: #f4f3ef;
  border-radius: 6px;
  max-width: 380px;
  width: 100%;
  margin-right: 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 2px #ccc5b980;
  border: 1px solid #ccc;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 19px;
    border-bottom: 1px solid #cecfd1;
    background: #e2ecdc;
    &--icons {
      display: inline-flex;
    }
    span {
      display: flex;
      align-items: center;
    }
    &--indicator {
      margin-right: 10px;
    }

    &--text {
      color: black;
      font-size: 13px;
    }
    &--more {
      text-transform: uppercase;
      font-size: 24px;
      color: black;
    }
    &--svg {
      font-size: 24px;
      color: black;
      margin: 0 5px 0 auto;
    }
  }
  &__container {
    padding: 5px 19px;

    &--row {
      margin: 14px 0;
      display: flex;
      align-items: center;
      .title {
        max-width: 150px;
        font-size: 13px;
        width: 100%;
        margin-right: 10px;
        color: black;
        text-align: left;
      }
      .text {
        display: flex;
        font-size: 13px;
        color: black;
        align-items: center;
        .db-indicator {
          margin-right: 10px;
          padding: 4px 10px;
          border-radius: 2px;
          color: white;
        }
        .mdi-sim-off {
          display: block;
        }
        .changes {
          opacity: 0.4;
          color: gray;
          font-size: 13px;
          border-bottom: 1px solid gray;
          border-bottom-style: dashed;
        }
      }
    }
  }
}

.bar-singal {
  display: flex;
  margin-left: 5px;
  div {
    width: 5px;
    height: 15px;
    margin: 0 2px;
    border: 1px solid gray;
  }
}
</style>
